import { render } from "./TopbarActivity.vue?vue&type=template&id=59a0dc1f"
import script from "./TopbarActivity.vue?vue&type=script&lang=js"
export * from "./TopbarActivity.vue?vue&type=script&lang=js"
script.render = render

export default script